<template>
  <ClientOnly v-if="currentFeature">
    <article class="feature-card">
      <span class="feature-card__gradient" />
      <Component :is="currentFeature" />
    </article>
  </ClientOnly>
</template>

<script>
import { mapGetters } from 'vuex'
const STEPS = [1, 2, 3, 5, 7]
const Features = {
  registration: () => import('./Registration'),
  welcomeBonus: () => import('./WelcomeBonus'),
}
export default {
  name: 'SliderSwiperFeature',
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'user', 'isUserLoaded']),
    ...mapGetters('base', ['isServerToken']),
    showSlides() {
      return (this.user.payin_count || this.user.payin_count === 0) && STEPS.includes(this.user.payin_count + 1)
    },
    isAuth() {
      return this.isLoggedIn
    },
    currentFeature() {
      if (this.isAuth && this.showSlides) return Features.welcomeBonus
      else if (this.isAuth && !this.showSlides) return null
      else return Features.registration
    },
  },
}
</script>

<style scoped lang="scss" src="./style.scss">
